import { DevClaimViewModel } from "@lumora/core";
import { DevClaimForm } from "@lumora/ui";
import { useMemo } from "react";
import { client } from "../client.js";

/** Honeypot input name; must match the API's `website` unless the server config changes it. */
const HONEYPOT_FIELD = (import.meta.env?.["VITE_CLAIM_HONEYPOT_FIELD"] as string | undefined) || "website";

/** Slug claim section under the Get started form (#1412): verified email, availability, claim. */
export function GetStartedClaim() {
  const vm = useMemo(() => new DevClaimViewModel(client, { honeypotField: HONEYPOT_FIELD }), []);
  return (
    <section className="site-get-started-claim" aria-labelledby="claim-heading" data-lumora-view="get-started-claim">
      <h2 id="claim-heading">Reserve your site name</h2>
      <DevClaimForm viewModel={vm} showTitle={false} />
    </section>
  );
}
